// File utility functions for email attachments

/**
 * Convert a File to base64 string
 */
export async function fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const result = reader.result as string;
            // Remove data URL prefix (e.g., "data:image/jpeg;base64,")
            const base64 = result.split(',')[1];
            resolve(base64);
        };
        reader.onerror = (error) => reject(error);
    });
}

/**
 * Convert FileList to array of base64 attachments
 */
export async function fileListToAttachments(fileList: FileList | null): Promise<Array<{ name: string; content: string }>> {
    if (!fileList || fileList.length === 0) {
        return [];
    }

    const attachments = [];
    for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        try {
            const base64 = await fileToBase64(file);
            attachments.push({
                name: file.name,
                content: base64
            });
        } catch (error) {
        }
    }

    return attachments;
}

/**
 * Convert a single File to attachment format
 */
export async function fileToAttachment(file: File | null | undefined): Promise<Array<{ name: string; content: string }>> {
    if (!file) {
        return [];
    }


    try {
        const base64 = await fileToBase64(file);
        
        if (!base64 || base64.length === 0) {
            return [];
        }

        const attachment = {
            name: file.name,
            content: base64
        };

        return [attachment];
    } catch (error) {
        return [];
    }
}

